import React from 'react';

interface CardFooterProps {}

export const CardFooter: React.FC<CardFooterProps> = ({ children }) => {
  return (
    <footer className="flex justify-end w-full mt-6 bg-gray-100 rounded-b-lg">
      {children}
    </footer>
  );
};

export default CardFooter;
